import { render } from "./SpaceList.vue?vue&type=template&id=2e7e6c9c&scoped=true"
import script from "./SpaceList.vue?vue&type=script&lang=js"
export * from "./SpaceList.vue?vue&type=script&lang=js"

import "./SpaceList.vue?vue&type=style&index=0&id=2e7e6c9c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src739691156/src/fellow/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7e6c9c"]])

export default __exports__